import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { config } from './config';
import { main } from './configuration';
import { handleLoginRedirect } from './configuration/login/redirect';
import { store } from './configuration/setup/store';
import App from './features/app/App';
import { ErrorBoundary } from './features/app/ErrorBoundary';
import ErrorFallback from './features/app/ErrorFallback';

const renderApplication = () => {
    createRoot(document.getElementById('root') as HTMLElement).render(
        <ErrorBoundary fallback={<ErrorFallback />}>
            <Provider store={store}>
                <App />
            </Provider>
        </ErrorBoundary>
    );
};

if (window.location.href.startsWith(config.login.redirectUri as string)) {
    handleLoginRedirect();
} else {
    main(renderApplication);
}
